import { apis } from 'utils/lib/apis';
import { logToSentry } from 'utils/networkErrorUtils';
import * as Actions from './actions';

export const handleCloneLoteria = (payload) => async (dispatch) => {
  try {
    const cleanPayload = {
      loteria_id: String(payload?.loteria_id || ''),
      book_id: payload?.book_id ? (typeof payload.book_id === 'string' ? payload.book_id : String(payload.book_id)) : null,
      page_id: payload?.page_id ? (typeof payload.page_id === 'string' ? payload.page_id : String(payload.page_id)) : null,
      confirm: Boolean(payload?.confirm || false),
      role: payload?.role || '',
      user_id: payload?.user_id || ''
    };

    const response = await apis.post('oneway_bingo', `/cloneBingo`, {
      body: cleanPayload
    });

    if (response?.warning === true) {
      return {
        warning: true,
        message: response?.message || "If you want to clone again same loteria you already clone it previously",
        existing_clones: response?.existing_clones || 0
      };
    }

    if (response && response.id) {
      await dispatch(Actions.createOnewayBingo(response));
      return { success: true, data: response };
    } else {
      return { success: false, error: response?.error || response?.message || "Failed to clone loteria" };
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      const errorMessage = error?.message || 'Unknown error';
      const cleanError = new Error(errorMessage);
      if (error?.stack) {
        cleanError.stack = error.stack;
      }
      logToSentry({
        message: 'cloning loteria',
        error: cleanError,
        module: 'BINGO',
        operation: 'CLONE_LOTERIA'
      });
    }
    return { success: false, error: error?.message || "An error occurred" };
  }
};

